// Mock data for Golf Nuts website
// Cleaned up: Removed unused exports (hosts, guests, episodes, series)
// Only keeping siteConfig and membershipBenefits which are used by active components

export const siteConfig = {
  siteName: 'Golf Nuts',
  tagline: 'The golf world\'s group chat',
  description: 'Just friends, stories, and everything we love about the game.',
  
  // Social Links (configurable)
  social: {
    instagram: {
      handle: '@golfnutspodcast',
      url: 'https://instagram.com/golfnutspodcast'
    },
    twitter: {
      handle: '@golfnutspod',
      url: 'https://twitter.com/golfnutspod'
    },
    youtube: {
      channelUrl: 'https://youtube.com/@golfnutspodcast',
      channelId: 'UCxxxxxx'
    }
  },
  
  // Podcast Platform Links (configurable)
  podcast: {
    spotify: 'https://open.spotify.com/show/xxxxx',
    apple: 'https://podcasts.apple.com/us/podcast/xxxxx',
    youtube: 'https://youtube.com/@golfnutspodcast'
  }
};

export const membershipBenefits = [
  {
    title: 'Member Giveaways',
    description: 'Exclusive contests for engaged subscribers'
  },
  {
    title: 'Member Clubhouse App Access',
    description: 'Our private community experience'
  },
  {
    title: 'Clubhouse GHIN Tracker',
    description: 'Leaderboards & monthly/quarterly competitions (GHIN Link Coming Soon)'
  },
  {
    title: 'The Turn Newsletter',
    description: 'Weekly insider stories, picks, and updates'
  },
  {
    title: 'Event Priority Access',
    description: 'First dibs on scrambles, meetups, and trips'
  },
  {
    title: 'Discounts to Partnered Brands',
    description: 'Coming soon'
  }
];
